<template>
  <div>
    <div v-if="retornaSite() == 'Weddbets'">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="d-flex justify-content-center">
            <a href="/" v-if="$sessao && $sessao.usuario.site == 'Weddbets'">
              <img
                class="img-fluid"
                :src="carregarLogo()"
                style="
                  margin-left: 20px;
                  max-height: 120px;
                  margin-bottom: 25px;
                "
              />
            </a>
            <a
              href="/"
              v-if="
                $sessao && $sessao.usuario.site == 'Bll' && $darkMode == 'true'
              "
            >
              <img
                src="/assets/logobll2.png"
                class="img-fluid"
                style="
                  max-height: 160px;
                  margin-bottom: 25px;
                  margin-top: 30px;
                  margin-left: 10px;
                "
              />
            </a>
            <a
              href="/"
              v-if="
                $sessao && $sessao.usuario.site == 'Bll' && $darkMode == 'false'
              "
            >
              <img
                src="/assets/logobll3.png"
                class="img-fluid"
                style="
                  max-height: 160px;
                  margin-bottom: 25px;
                  margin-top: 30px;
                  margin-left: 10px;
                "
              />
            </a>
          </div>
        </div>
      </div>

      <div class="row d-block d-sm-none">
        <div class="col">
          <nav
            class="navbar navbar-expand-sm"
            style="padding: 0px; margin: 0px; padding-top: 10px"
          >
            <h5 class="navbar-brand text-success" style="margin-bottom: 0px">
              <b v-if="retornaSite() == 'Weddbets'">WeddBets!</b>
            </h5>

            <button
              class="navbar-toggler float-right"
              type="button"
              data-toggle="collapse"
              data-target="#navbar-collapse"
            >
              ☰
            </button>

            <div
              class="collapse navbar-collapse"
              id="navbar-collapse"
              style="margin-top: 10px"
            >
              <ul class="nav navbar-nav ml-auto">
                <a
                  class="btn btn-outline-secondary"
                  style="margin-bottom: 10px"
                  href="/"
                  >Home</a
                >
                <a
                  class="btn btn-outline-secondary"
                  style="margin-bottom: 10px"
                  href="/fav"
                  >Favorito</a
                >
                <a
                  v-if="
                    (isAdmin || retornaTipoUsuario() == 'Apresentador') &&
                    !isAdminSite
                  "
                  class="btn btn-outline-secondary"
                  style="margin-bottom: 10px"
                  href="/eventos"
                  >Eventos</a
                >
                <a
                  v-if="isAdmin || retornaTipoUsuario() == 'Apresentador'"
                  class="btn btn-outline-secondary"
                  style="margin-bottom: 10px"
                  href="/sessoes"
                  >Sessões</a
                >
                <a
                  v-if="isAdmin"
                  class="btn btn-outline-secondary"
                  style="margin-bottom: 10px"
                  href="/admin"
                  >Admin</a
                >
                <a
                  v-if="retornaTipoUsuario() !== 'Degustação'"
                  class="btn btn-outline-secondary"
                  style="margin-bottom: 10px"
                  href="/meus-dados"
                  >Meus dados</a
                >
                <a
                  class="btn btn-outline-secondary btn-sm"
                  href="·"
                  style="margin-right: 5px"
                  @click="sair()"
                  >Sair</a
                >
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div class="row d-none d-sm-block">
        <div class="col offset-md-1 col-md-10">
          <a
            class="btn btn-outline-secondary btn-sm"
            href="/"
            style="min-width: 60px; margin-right: 2px; min-width: 95px"
          >
            Home
            <span class="sr-only">(current)</span>
          </a>
          <a
            class="btn btn-outline-secondary btn-sm"
            href="/fav"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
          >
            Favorito
          </a>
          <a
            v-if="
              (isAdmin || retornaTipoUsuario() == 'Apresentador') &&
              !isAdminSite
            "
            class="btn btn-outline-secondary btn-sm"
            href="/eventos"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Eventos</a
          >
          <a
            v-if="isAdmin || retornaTipoUsuario() == 'Apresentador'"
            class="btn btn-outline-secondary btn-sm"
            href="/sessoes"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Sessões</a
          >
          <a
            v-if="isAdmin"
            class="btn btn-outline-secondary btn-sm"
            href="/admin"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Admin</a
          >
          <a
            v-if="retornaTipoUsuario() !== 'Degustação'"
            class="btn btn-outline-secondary btn-sm"
            href="/meus-dados"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Meus dados</a
          >
          <a
            class="btn btn-outline-secondary btn-sm"
            href="#"
            style="margin-left: 2px; min-width: 95px"
            @click="sair()"
            >Sair</a
          >
          <hr />
        </div>
      </div>
    </div>
    <div v-if="retornaSite() == 'Bll'">
      <div class="row d-block" style="zoom: 1; margin-bottom: 10px">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <a
            href="/"
            v-if="
              $sessao && $sessao.usuario.site == 'Bll' && $darkMode == 'true'
            "
          >
            <img
              class="img-fluid"
              src="/assets/logobll2.png"
              style="max-height: 130px"
            />
          </a>
          <a
            href="/"
            v-if="
              $sessao && $sessao.usuario.site == 'Bll' && $darkMode == 'false'
            "
          >
            <img
              class="img-fluid"
              src="/assets/logobll3.png"
              style="max-height: 130px"
            />
          </a>
          <a href="/" v-if="$sessao && $sessao.usuario.site == 'Weddbets'">
            <img
              class="img-fluid"
              src="/assets/logoc.png"
              style="max-height: 130px; margin-bottom: 25px"
            />
          </a>
        </div>
      </div>
      <div class="row" style="zoom: 1; margin-bottom: 10px">
        <div class="col-md-12 d-flex justify-content-center" style="">
          <span
            ><a
              class="btn btn-dark btn-sm"
              style="
                zoom: 1;
                margin-top: 10px;
                margin-right: 5px;
                background-color: rgb(80 82 85);
              "
              href="/"
              >Home</a
            ></span
          >
          <span
            ><a
              class="btn btn-dark btn-sm"
              style="
                zoom: 1;
                margin-top: 10px;
                margin-right: 5px;
                background-color: rgb(80 82 85);
              "
              href="/fav"
              >Favorito</a
            ></span
          >
          <span>
            <a
              v-if="retornaTipoUsuario() !== 'Degustação'"
              class="btn btn-dark btn-sm"
              style="
                zoom: 1;
                margin-top: 10px;
                margin-right: 5px;
                background-color: rgb(80 82 85);
              "
              href="/meus-dados"
            >
              Meus dados
            </a>
          </span>
          <span>
            <button
              type="button"
              class="btn btn-dark btn-sm"
              style="zoom: 1; margin-top: 10px; background-color: rgb(80 82 85)"
              @click="sair()"
            >
              Sair
            </button>
          </span>
        </div>
      </div>
    </div>
    <div v-if="retornaSite() == 'Stream1x2'">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="d-flex justify-content-center">
            <a href="/">
              <img
                class="img-fluid"
                src="/assets/StreamTrader.png"
                style="
                  max-height: 170px;
                  margin-bottom: 10px;
                  max-width: 390px;
                  width: 100%;
                "
              />
            </a>
          </div>
        </div>
      </div>

      <div class="row d-block d-sm-none">
        <div class="col">
          <nav
            class="navbar navbar-expand-sm"
            style="padding: 0px; margin: 0px; padding-top: 10px"
          >
            <button
              class="navbar-toggler float-right"
              type="button"
              data-toggle="collapse"
              data-target="#navbar-collapse"
            >
              ☰
            </button>

            <div
              class="collapse navbar-collapse"
              id="navbar-collapse"
              style="margin-top: 10px"
            >
              <ul class="nav navbar-nav ml-auto">
                <a
                  class="btn btn-dark btn-sm"
                  style="margin-bottom: 10px"
                  href="/"
                  >Home</a
                >
                <a
                  v-if="isAdmin"
                  class="btn btn-dark btn-sm"
                  style="margin-bottom: 10px"
                  href="/admin"
                  >Admin</a
                >
                <a
                  v-if="isAdmin"
                  class="btn btn-dark btn-sm"
                  style="margin-bottom: 10px"
                  href="/sessoes"
                  >Sessões</a
                >
                <a
                  v-if="retornaTipoUsuario() !== 'Degustação'"
                  data-toggle="modal"
                  data-target="#dialogEditMeusDados"
                  role="button"
                  class="btn btn-dark btn-sm"
                  style="margin-bottom: 10px"
                  type="button"
                  href="#"
                  >Profile</a
                >
                <a class="btn btn-dark btn-sm" href="·" style="" @click="sair()"
                  >Logout</a
                >
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div class="row d-none d-sm-block">
        <div class="col offset-md-1 col-md-10">
          <a
            class="btn btn-dark btn-sm"
            href="/"
            style="min-width: 60px; margin-right: 2px; min-width: 95px"
          >
            Home
            <span class="sr-only">(current)</span>
          </a>

          <a
            v-if="isAdmin"
            class="btn btn-dark btn-sm"
            href="/admin"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Admin</a
          >
          <a
            v-if="isAdmin"
            class="btn btn-dark btn-sm"
            href="/sessoes"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Sessões</a
          >
          <a
            v-if="retornaTipoUsuario() !== 'Degustação'"
            data-toggle="modal"
            data-target="#dialogEditMeusDados"
            role="button"
            class="btn btn-dark btn-sm"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            type="button"
            href="#"
            >Profile</a
          >
          <a
            class="btn btn-dark btn-sm"
            href="#"
            style="margin-left: 2px; min-width: 95px"
            @click="sair()"
            >Logout</a
          >
        </div>
      </div>
    </div>
    <div v-if="retornaSite() == 'Share'">
      <div class="row" style="">
        <div class="col-md-12 text-center" style="">
          <h1>{{ retornaTitulo() }}</h1>
        </div>
      </div>
      <div class="row" style="zoom: 1; margin-bottom: 10px">
        <div class="col-md-12 text-center" style="">
          <a
            class="btn btn-secondary btn-sm"
            href="/"
            style="min-width: 60px; margin-right: 2px; min-width: 95px"
          >
            Home
            <span class="sr-only">(current)</span>
          </a>
          <a
            v-if="isAdmin"
            class="btn btn-secondary btn-sm"
            href="/usuarios"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Usuários</a
          >
          <a
            v-if="
              (isAdmin || retornaTipoUsuario() == 'Apresentador') &&
              !isAdminSite
            "
            class="btn btn-secondary btn-sm"
            href="/eventos"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Eventos</a
          >
          <a
            v-if="isAdmin"
            class="btn btn-secondary btn-sm"
            href="/sessoes"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Sessões</a
          >
          <a
            class="btn btn-secondary btn-sm"
            href="/meus-dados"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Meus dados</a
          >
          <a
            class="btn btn-secondary btn-sm"
            href="#"
            style="margin-left: 2px; min-width: 95px"
            @click="sair()"
            >Sair</a
          >
        </div>
      </div>
      <hr />
    </div>

    <div v-if="retornaSite() == 'ShareApp'">
      <div class="row" style="">
        <div class="col-md-12 text-center" style="">
          <h1>{{ retornaTitulo() }}</h1>
        </div>
      </div>
      <div class="row" style="zoom: 1; margin-bottom: 10px">
        <div class="col-md-12 text-center" style="">
          <a
            class="btn btn-secondary btn-sm"
            href="/"
            style="min-width: 60px; margin-right: 2px; min-width: 95px"
          >
            Home
            <span class="sr-only">(current)</span>
          </a>
          <a
            v-if="isAdmin"
            class="btn btn-secondary btn-sm"
            href="/usuarios"
            style="margin-left: 2px; margin-right: 2px; min-width: 95px"
            >Usuários</a
          >
          <a
            class="btn btn-secondary btn-sm"
            href="#"
            style="margin-left: 2px; min-width: 95px"
            @click="sair()"
            >Sair</a
          >
        </div>
      </div>
      <hr />
    </div>

    <div
      v-if="retornaSite() == '7live'"
      style="background-color: #1c3868; margin-bottom: 10px"
    >
      <div class="row" style="background-color: #1c3868; padding: 0 !important">
        <div class="col-md-12 d-flex justify-content-center">
          <a href="/">
            <img
              class="img-fluid"
              :src="carregarLogo()"
              style="margin-bottom: 20px; margin-top: 30px; max-width: 300px"
            />
          </a>
        </div>
      </div>
      <div class="row" style="background-color: #1c3868; padding: 0 !important">
        <div class="col-md-12 d-flex justify-content-center">
          <div
            style="width: 100px; height: 70px; background-color: white"
            v-bind:class="{
              headerNMenuNormal4: retornaRouteName() !== 'home',
              headerNMenuSelecionado4: retornaRouteName() == 'home',
            }"
          >
            <a class="text-secondary" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-play-btn-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                ></path>
              </svg>
              <h6>
                <small><b>Ao vivo</b></small>
              </h6>
            </a>
          </div>
          <div
            style="width: 100px; height: 70px; background-color: white"
            v-bind:class="{
              headerNMenuNormal4: retornaRouteName() !== 'programacao',
              headerNMenuSelecionado4: retornaRouteName() == 'programacao',
            }"
          >
            <a class="text-secondary" href="/agenda">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-calendar-week"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                />
                <path
                  d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                />
              </svg>
              <h6>
                <small><b>Agenda</b></small>
              </h6>
            </a>
          </div>
          <div
            style="width: 100px; height: 70px; background-color: white"
            v-bind:class="{
              headerNMenuNormal4: retornaRouteName() !== 'eventos',
              headerNMenuSelecionado4: retornaRouteName() == 'eventos',
            }"
            v-if="
              (isAdmin || retornaTipoUsuario() == 'Apresentador') &&
              !isAdminSite &&
              $siteAdmin == true
            "
          >
            <a class="text-secondary" href="/eventos">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-calendar-plus-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.5 8.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5a.5.5 0 0 1 1 0z"
                />
              </svg>
              <h6>
                <small><b>Eventos</b></small>
              </h6>
            </a>
          </div>
          <div
            style="width: 100px; height: 70px; background-color: white"
            v-if="
              $siteAdmin && (isAdmin || retornaTipoUsuario() == 'Apresentador')
            "
            v-bind:class="{
              headerNMenuNormal4: retornaRouteName() !== 'sessoes',
              headerNMenuSelecionado4: retornaRouteName() == 'sessoes',
            }"
          >
            <a class="text-secondary" href="/sessoes">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-diagram-3-fill"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                />
              </svg>
              <h6>
                <small><b>Sessões</b></small>
              </h6>
            </a>
          </div>
          <div
            style="width: 100px; height: 70px; background-color: white"
            v-if="isAdmin && $siteAdmin"
            v-bind:class="{
              headerNMenuNormal4: retornaRouteName() !== 'administracao',
              headerNMenuSelecionado4: retornaRouteName() == 'administracao',
            }"
          >
            <a class="text-secondary" href="/admin">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-people"
                viewBox="0 0 16 16"
              >
                <path
                  d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                />
              </svg>
              <h6>
                <small><b>Admin</b></small>
              </h6>
            </a>
          </div>
          <div
            style="width: 100px; height: 70px; background-color: white"
            v-if="retornaTipoUsuario() !== 'Degustação'"
            v-bind:class="{
              headerNMenuNormal4: retornaRouteName() !== 'meus-dados',
              headerNMenuSelecionado4: retornaRouteName() == 'meus-dados',
            }"
          >
            <a class="text-secondary" href="/conta">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-person-circle"
                viewBox="0 0 16 16"
              >
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                <path
                  fill-rule="evenodd"
                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                />
              </svg>
              <h6>
                <small><b>Conta</b></small>
              </h6>
            </a>
          </div>
          <div
            style="width: 100px; height: 70px; background-color: white"
            class="headerNMenuNormal4 text-secondary"
          >
            <a class="text-secondary" @click="sair()" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="margin-top: 10px"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                />
              </svg>
              <h6>
                <small><b>Sair</b></small>
              </h6>
            </a>
          </div>
        </div>
      </div>
    </div>

    <EditUsuario
      v-if="
        retornaSite() == 'Share' || retornaSite() == 'Stream1x2'
      "
      ref="editUsuario"
      :propMeusDados="true"
      :propVencimento="true"
    />
  </div>
</template>

<script>
import EditUsuario from "../edits/EditUsuario";

export default {
  name: "Header",
  components: { EditUsuario },
  methods: {
    retornaRouteName() {
      return this.$route.name;
    },
    retornaTitulo() {
      return process.env.VUE_APP_TITULO;
    },
    carregarLogo() {
      if (this.$site == "Weddbets") {
        return "/assets/logoc.png";
      }

      if (this.$site == "7live") {
        return "/assets/logo_stadiums.png";
      }

      return "";
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    retornaSite() {
      return this.$site;
    },
    atualizarItens() {
      window.document.getElementById(`atualizarItens`).click();
    },
    sair() {
      localStorage.removeItem("ckd");
      localStorage.removeItem("ckdCch");
      this.$router.go({ name: "login" });
    },
  },
  mounted() {
    this.isAdmin = false;
    this.isAdminSite = false;

    if (this.$sessao) {
      this.isAdmin =
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Administrador Site";
      this.isAdminSite =
        this.$sessao.usuario.tipoUsuario == "Administrador Site";
    }
  },
  data: function () {
    return {
      isAdmin: false,
      isAdminSite: false,
    };
  },
};
</script>

<style>
.headerMenuNormal4 {
  height: 80px;
  border-radius: 0px;
  width: 110px;
  background-color: white;
  border-top: 1px solid #1c3868;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid #1c3868;
}
.headerMenuSelecionado4 {
  height: 80px;
  border-radius: 0px;
  width: 110px;
  background-color: white;
  border-top: 1px solid #1c3868;
  border-left: 0;
  border-right: 0;
  border-bottom: 0px solid #1c3868;
}

.headerNMenuNormal4 {
  border-top: 1px solid #1c3868;
  border-left: 1px solid #1c3868;
  border-right: 0;
  border-bottom: 1px solid #1c3868;
}
.headerNMenuSelecionado4 {
  border-top: 1px solid #1c3868;
  border-left: 1px solid #1c3868;
  border-right: 0;
  border-bottom: 0px solid #1c3868;
}
</style>
